import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "center" }
const _hoisted_2 = { id: "main-contents" }
const _hoisted_3 = { id: "footer" }
const _hoisted_4 = { class: "footer-content" }
const _hoisted_5 = { class: "footer-links" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "footer-sep" }, "|", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "footer-sep" }, "|", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "footer-sep" }, "|", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:purecrystar@gmail.com" }, "purecrystar@gmail.com", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "footer-copy" }, "© 2026 Breezer. All rights reserved.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponentVue = _resolveComponent("HeaderComponentVue")!
  const _component_MenuComponentVue = _resolveComponent("MenuComponentVue")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderComponentVue),
    _createVNode(_component_MenuComponentVue),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("소개")
            ]),
            _: 1
          }),
          _hoisted_6,
          _createVNode(_component_router_link, { to: "/user/terms-of-service" }, {
            default: _withCtx(() => [
              _createTextVNode("이용약관")
            ]),
            _: 1
          }),
          _hoisted_7,
          _createVNode(_component_router_link, { to: "/user/terms" }, {
            default: _withCtx(() => [
              _createTextVNode("개인정보 처리방침")
            ]),
            _: 1
          }),
          _hoisted_8,
          _hoisted_9
        ]),
        _hoisted_10
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showScrollTop)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "scroll-top-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
              "aria-label": "맨 위로"
            }, " ▲ "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_CookieConsent)
  ], 64))
}